
const clientStorageNames = {

 USER_TOKEN: {
    name: "userToken"
},
 REFRESH_TOKEN : {
    name: "refreshToken"
},
FIRST_NAME : {
    name: "firstName"
},
LAST_NAME : {
    name: "lastName"
},
EMAIL : {
    name: "email"
},
PHONE : {
    name: "phone"
},
 CITY : {
    name: "city"
},
STATE : {
    name: "state"
},
ZIPCODE : {
    name: "zipcode"
},
USER_ID : {
    name: "userId"
},
ACCIDENT_ID : {
    name: "accidentId"
},
ACCIDENT_TYPE : {
    name: "accidentType"
},
 ACCIDENT_TIME : {
    name: "accidentTime"
},
VEHICLE_SPEED : {
    name: "vehicleSpeed"
},
ACCIDENT_LOCATION : {
    name: "accidentLocation"
},
VEHICLE_MAKE : {
    name: "vehicleMake"
},
VEHICLE_MODEL : {
    name: "vehicleModel"
},
 VEHICLE_YEAR : {
    name: "vehicleYear"
},
TIME_SUBMITTED : {
    name: "timeSubmitted"
},
SUCCESSFUL_FILES : {
    name: "successfulFiles"
},
UNSUCCESSFUL_FILES : {
    name: "unsuccessfulFiles"
},
ADDITIONAL_TEXT : {
    name: "additionalText"
},
POLICY_ID : {
    name: "policyId"
},
ACCIDENT_NAME : {
    name: "accidentName"
},
ACCIDENT_DATE : {
    name: "accidentDate"
},
SERVICES_REQUESTED:{
name: "servicesRequested"
},
POLICY_NAME : {
    name: "policyName"
},
PROVIDER_NAME : {
    name: "providerName"
},
POLICY_ADDRESS : {
    name: "policyAddress"
},
VIN_NUMBER : {
    name: "vinNumber"
},
LICENSE_NO : {
    name: "licenseNumber"
},
VEHICLE_LIST : {
    name: "vehicleList"
},
AGENT_NAME : {
    name: "agentName"
},
AGENT_PHONE : {
    name: "agentPhone"
}

}

module.exports = {clientStorageNames}


// WEBPACK FOOTER //
// ./src/services/libraries/clientStoragelib.js